import styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const StyledCommentInput = styled(Grid)`
  position: relative;
  margin-bottom: 18px;
  width: 100%;

  .send-icon {
    position: absolute;
    top: 0px;
    right: 2px;
  }
`;
